// Auto-recover from stale-deploy chunk load failures.
//
// After a new production build ships, a client still running the old HTML (or
// caught mid-rollout while pods have mixed builds) can request a code-split
// chunk whose hash no longer exists on the pod that serves it. webpack throws a
// "ChunkLoadError" / "Loading chunk N failed". With content-hashed filenames
// this is unrecoverable in-page, but a full reload fetches the current HTML +
// chunks and fixes it.
//
// We reload once, guarded by a short time window in sessionStorage so a chunk
// that is genuinely gone (not just a transient deploy skew) can't cause an
// infinite reload loop. If storage is unavailable we skip the auto-reload rather
// than risk looping.

const RELOAD_MARKER = "__chunkReloadAt";
const RELOAD_WINDOW_MS = 10000;

const isChunkLoadError = (err) => {
  if (!err) return false;
  const name = err.name || "";
  const message = err.message || (typeof err === "string" ? err : "") || "";
  return (
    name === "ChunkLoadError" ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /importing a module script failed/i.test(message)
  );
};

const reloadOnce = () => {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_MARKER)) || 0;
    // Already reloaded within the window: the chunk is genuinely missing, not a
    // transient skew — stop here so we don't loop forever.
    if (Date.now() - last < RELOAD_WINDOW_MS) return;
    window.sessionStorage.setItem(RELOAD_MARKER, String(Date.now()));
  } catch {
    // Storage blocked (e.g. hardened privacy mode): we can't guard against a
    // loop, so don't auto-reload. The user can refresh manually.
    return;
  }
  window.location.reload();
};

window.addEventListener("error", (event) => {
  if (isChunkLoadError(event && event.error)) reloadOnce();
});

window.addEventListener("unhandledrejection", (event) => {
  if (isChunkLoadError(event && event.reason)) reloadOnce();
});
